/**
 * La teinte et l'icône de chaque widget.
 *
 * Tenues ici plutôt que dans chaque composant : le panneau « Personnaliser »
 * les montre aussi, et un widget qui changerait de couleur entre la liste et
 * l'accueil ne se reconnaîtrait plus. Ce fichier ne dépend de rien, pour que
 * les widgets comme le registre puissent l'importer sans boucle.
 */
const APPARENCES = {
    bienvenue: { teinte: 'indigo', icone: 'mdi:weather-sunset' },
    raccourcis: { teinte: 'indigo', icone: 'mdi:lightning-bolt-outline' },
    'mes-taches': { teinte: 'violet', icone: 'mdi:format-list-checks' },
    'mon-equipe': { teinte: 'violet', icone: 'mdi:account-group-outline' },
    notifications: { teinte: 'ciel', icone: 'mdi:bell-outline' },
    tickets: { teinte: 'corail', icone: 'mdi:lifebuoy' },
    'postes-en-defaut': { teinte: 'ambre', icone: 'mdi:phone-alert-outline' },
    'ca-du-mois': { teinte: 'emeraude', icone: 'mdi:chart-line' },
    'factures-achat-a-ventiler': { teinte: 'rose', icone: 'mdi:receipt-text-outline' },
    'stock-alertes': { teinte: 'ambre', icone: 'mdi:package-variant-closed' },
    nouveautes: { teinte: 'rose', icone: 'mdi:creation-outline' },
}

const NEUTRE = { teinte: 'indigo', icone: 'mdi:view-dashboard-outline' }

export function apparenceDe(cle) {
    return APPARENCES[cle] ?? NEUTRE
}
